/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { max, sqrt, exp, pow } = Math;

export default class Energise extends Phase {
	getPreludeLength() {
		return 0;
	}
	getPostludeLength() {
		return 0;
	}
	run({ time, frame_opts, pulse }) {
		frame_opts.size *= 1 + 0.5 * pow(max(0, pulse * 3 - 2), 10);
		for (let beat = 0; beat < time.beat; beat++) {
			frame_opts.shimmer.frequency[beat] = 1 << beat;
			frame_opts.shimmer.magnitude[beat] = 0.2 / sqrt(1 + beat);
		}
		const flip_rate = time.relative < 3.5 ? 53 : 27;
		frame_opts.shimmer.shift = pow(pulse, 4);
		frame_opts.shimmer.scale = (time.relative * flip_rate) & 1 ? 1 : -1;
		frame_opts.shimmer.skew = -0.4 / (1 + time.beat * time.beat);
		frame_opts.rotation -= time.relative / 8;
		if (time.relative > this.length - 1) {
			frame_opts.shimmer.scale *= exp(6 * (time.relative - (this.length - 1)));
		}
	}
}
